export class referralDto {
    emails: string[];
    message:string;
}
